import Image from '~/components/image/Image'
import { PAYPAY_GOURMET_WHITE_IMAGE_URL } from '~/lib/constants/constants'

const PaypayGourmetWhiteLogo = () => {
  return <Image width={126} height={22} alt="PayPayグルメ" src={PAYPAY_GOURMET_WHITE_IMAGE_URL} />
}

export default PaypayGourmetWhiteLogo
